/* tslint:disable */
import { Injectable } from '@angular/core';
import {
  HttpClient, HttpRequest, HttpResponse, 
  HttpHeaders, HttpParams } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { Observable } from 'rxjs/Observable';
import { map } from 'rxjs/operators/map';
import { filter } from 'rxjs/operators/filter';

import { TypeAny } from '../models/type-any';


@Injectable()
export class PermissionsService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   */
  getPermissionsResponse(): Observable<HttpResponse<TypeAny[]>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    let req = new HttpRequest<any>(
      "GET",
      this.rootUrl + `/permissions`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      filter(_r => _r instanceof HttpResponse),
      map(_r => {
        let _resp = _r as HttpResponse<any>;
        let _body: TypeAny[] = null;
        _body = _resp.body as TypeAny[]
        return _resp.clone({body: _body}) as HttpResponse<TypeAny[]>;
      })
    );
  }

  /**
   */
  getPermissions(): Observable<TypeAny[]> {
    return this.getPermissionsResponse().pipe(
      map(_r => _r.body)
    );
  }}

export module PermissionsService {
}
